import { FlagsProvider } from '@innovamat/flags';
import { ThemeProvider } from '@innovamat/glimmer-components';
import { RegionalConfigVariablesProvider } from '@innovamat/regional-config-variables';
import { WebviewBridgeProvider } from '@innovamat/webview-bridge';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './app/app-router';
import { queryClient } from './config/query-client';

const environment = import.meta.env.VITE_ENVIRONMENT || 'local';
const fastApiUrl = import.meta.env.VITE_GEOLOCATION_API || '';
const configCatKey = import.meta.env.VITE_CONFIG_CAT_KEY || '';
const configCatCacheTime = import.meta.env.VITE_CONFIG_CAT_CACHE_TIME || '1800';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider type="atlas">
        <QueryClientProvider client={queryClient}>
          <RegionalConfigVariablesProvider
            environment={environment}
            geolocationAPI={fastApiUrl}
          >
            <FlagsProvider sdkKey={configCatKey} cacheTime={configCatCacheTime}>
              <WebviewBridgeProvider>
                <AppRouter />
              </WebviewBridgeProvider>
            </FlagsProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </RegionalConfigVariablesProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
